import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import { useSetState } from "Helpers/Hooks";
import { CONSTRUCTION_RESULT } from "Stores/actionTypes";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";

const UsedItems = () => {
  const { constructionResult } = useSelector((state) => ({
    constructionResult: state.construction.constructionResult,
  }));
  const dispatch = useDispatch();
  const [showSelect, setShowSelect] = useState(true);
  const [controls, setControls] = useSetState({
    action: {
      type: "radio",
      value: { value: 12, key: "general_consumable" },
      items: [
        { value: 12, key: "general_consumable" },
        { value: 13, key: "per_unit_consumable" },
        { value: 15, key: "general_fittings" },
        { value: 16, key: "per_unit_fittings" },
        { value: 14, key: "technical_fittings" },
      ],
    },
    checkbox: {
      type: "checkbox",
      items: [
        { value: false, key: "isProfile" },
        { value: false, key: "isGlass" },
        { value: false, key: "isNet" },
        { value: false, key: "isFitting" },
        { value: false, key: "isOther" },
      ],
    },
    branchLength: {
      type: "millimeter",
      value: 6000,
      validation: {
        required: true,
        isNumeric: true,
        min: 4000,
        max: 12000,
      },
    },
  });

  const setValue = (name, value) => {
    setControls({ [name]: { value: value } });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        lenBranch: +value,
      },
    });
  };

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        Extra_UsedItems: value,
        action: value.value,
        // ... () => {
        //   if(value.value === 14) return { isFitting: true }
        //   else return null;
        // }
      },
    });

    if (value.value === 12 || value.value === 13) {
      setShowSelect(true);
    } else {
      setShowSelect(false);
    }
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
    const key = items[index].key;
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        [key]: e.currentTarget.checked,
      },
    });
  };

  const onChangeCheckbox_SelectAll = (e, name) => {
    let selected = {};
    setControls({
      [name]: {
        items: controls[name].items.map((inner) => {
          inner.value = true;
          selected[inner.key] = true;
          return inner;
        }),
      },
    });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        ...selected,
      },
    });
  };

  const onClear = () => {
    setControls({
      action: {
        value: constructionResult.Extra_UsedItems,
      },
    });
    setControls({
      branchLength: {
        value: constructionResult.lenBranch,
      },
    });
    setControls({
      checkbox: {
        items: [
          { value: constructionResult.isProfile, key: "isProfile" },
          { value: constructionResult.isGlass, key: "isGlass" },
          { value: constructionResult.isNet, key: "isNet" },
          { value: constructionResult.isFitting, key: "isFitting" },
          { value: constructionResult.isOther, key: "isOther" },
        ],
      },
    });
    setShowSelect(
      constructionResult.Extra_UsedItems.value === 12 ||
        constructionResult.Extra_UsedItems.value === 13
        ? true
        : false
    );
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        action: constructionResult.Extra_UsedItems.value,
        lenBranch: +constructionResult.lenBranch,
        pageIndex: 210,
      },
    });
  };

  useEffect(() => {
    onClear();
  }, []);

  return (
    <>
      <Grid container className="p-3">
        <Grid item xs={12} className="mb-2">
          <MuiRadioGroup
            name="action"
            value={controls.action.value}
            items={controls.action.items}
            onChange={onChangeRadio}
            translate={true}
            className="horizontalRadio"
          />
        </Grid>
        {showSelect && (
          <Grid container spacing={2} className="mt-2">
            <Grid item className="flex-sm-grow-0 flex-grow-1">
              <MuiCheckBoxGroup
                label={<Translator id={"selectPiecesGroup"} />}
                name="checkbox"
                value={controls.checkbox.value}
                items={controls.checkbox.items}
                onChange={onChangeCheckbox}
                translate={true}
                selectAllShow
                onSelectAll={onChangeCheckbox_SelectAll}
                className="horizontalCheckbox"
              />
            </Grid>
            <Grid item className="flex-sm-grow-0 flex-grow-1">
              <Input
                setValue={setValue.bind(this)}
                name="branchLength"
                value={controls.branchLength.value}
                validation={controls.branchLength.validation}
                label={<Translator id={"barLength"} />}
                type="text"
                endIcon={<Translator id="millimeter" />}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default UsedItems;
